import { motion } from "framer-motion";
import { MANIFESTO } from "@/lib/site";

export const Manifesto = () => {
  return (
    <section id="why" data-testid="manifesto-section" className="relative bg-zi-tint2 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-14 max-w-2xl">
          <p className="font-sans text-xs font-bold uppercase tracking-[0.2em] text-zi-accent">
            Why choose us
          </p>
          <h2 className="mt-4 font-heading text-4xl font-bold tracking-tight text-zi-ink sm:text-5xl lg:text-6xl">
            Why Choose Us.
          </h2>
        </div>

        <div className="divide-y divide-zi-line border-y border-zi-line">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.n}
              data-testid={`manifesto-item-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              className="grid grid-cols-1 items-center gap-6 py-10 md:grid-cols-12"
            >
              <div className="md:col-span-3">
                <span className="text-stroke font-heading text-7xl font-black leading-none sm:text-8xl">
                  {m.n}
                </span>
              </div>
              <h3 className="font-heading text-2xl font-bold text-zi-ink md:col-span-4 lg:text-3xl">
                {m.title}
              </h3>
              <p className="font-sans text-base leading-relaxed text-zi-muted md:col-span-5">
                {m.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
